// extracted by mini-css-extract-plugin
module.exports = {"scrollWrapper":"styles_scrollWrapper__10FNf","scrollContent":"styles_scrollContent__3Kpl9","scroll":"styles_scroll__2I68j","forSlider":"styles_forSlider__bd-sQ"};